<template>
  <div>
    <!-- Filtros y Ordenar-->
    <a-row type="flex" justify="space-between" :gutter="20" >
      <a-col :span="24" class="titulo">
        Filtros:
      </a-col>
      <a-col :span="24">
        <a-row type="flex" justify="space-between" :gutter="20" class="filtros">

          <a-col :span="12" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="clock-circle" />
            <a-range-picker
              class="shadowInputs"
              style="width: calc(100% - 25px);" 
              :placeholder="['Desde', 'Hasta']"  
              v-model="filters.periodo" 
              @change="filtrar()"
              format="D MMMM YYYY"
              :allowClear="tab_activa != '2'"
            />
          </a-col> 

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="search" />
            <a-input
              class="shadowInputs"
              style="width: calc(100% - 25px)"
              v-model="filters.subject"
              placeholder="Buscar por asunto"
              @change="filtrar(true)"
              />
          </a-col>

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="search" />
            <a-input
                class="shadowInputs"
                style="width: calc(100% - 25px)"
                v-model="filters.to"
                placeholder="Buscar por destinatario"
                @change="filtrar(true)"
            />
          </a-col>

          <a-col :span="6" style="display: flex;align-items: center;justify-content: space-between; margin-top: 10px">
            <a-icon type="search" />
            <a-input
                class="shadowInputs"
                style="width: calc(100% - 25px)"
                v-model="filters.from"
                placeholder="Buscar por remitente"
                @change="filtrar(true)"
            />
          </a-col>

          <a-col  :span="6" />
        </a-row>
      </a-col>
    </a-row>

    <!-- Resumen -->
    <a-row type="flex" justify="space-between" align="middle" style="margin-top: 20px;">

      <a-col :span="24" class="titulo">
        Resumen:
      </a-col>
      <a-col :span="24">
        <a-row type="flex" justify="space-between" align="middle" :gutter="20" class="resumen">
          <a-col :span="6">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="Cantidad de mails" :valor="format_number(dashboard.total)" />
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Recibidos" :valor="format_number(dashboard.deliveries)" :hover="porcentaje(dashboard.deliveries, dashboard.total)" />
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Abiertos" :valor="format_number(dashboard.opens)" :hover="porcentaje(dashboard.opens, dashboard.total)" />
            </a-card>
          </a-col>
          <a-col :span="6">
            <a-card :bordered='false' class="shadow">
              <detailHover titulo="#Clicks" :valor="format_number(dashboard.clicks)" :hover="porcentaje(dashboard.clicks, dashboard.total)"/>
            </a-card>
          </a-col>

        </a-row>
      </a-col>
    </a-row>

    <a-row type="flex" justify="space-between" style="margin-top: 20px;" :gutter="20">
      
      <!-- tabs -->
      <a-col :span="16" class="titulo" style="margin-bottom: 20px">
        <span @click="cargar_listado()" :class="(tab_activa != '1') ? 'tabNoSelect tab' : 'tab' ">Listado</span>
      </a-col>

      <!-- botones de header -->
      <a-col :span="4" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px" v-if="tab_activa == '1'">
        <a-icon :type="orden.asendente ? 'arrow-up' : 'arrow-down'" @click="orden.asendente = !orden.asendente; filtrar();"/>
        <a-select 
          style="width: calc(100% - 25px);" 
          placeholder="Ordenar" 
          v-model="orden.valor" 
          @change="filtrar()"
          allowClear
          class="shadowInputs">
          <a-select-option value="fecha">Fecha de Envio</a-select-option>
          <a-select-option value="personas"># Personas</a-select-option>
          <a-select-option value="abiertos"># Abiertos</a-select-option>
          <a-select-option value="clicks"># Clicks</a-select-option>
          <a-select-option value="conversiones"># Conversiones</a-select-option>
          <a-select-option value="costo">$ Costo</a-select-option>
          <a-select-option value="porcentaje_abiertos">% Abiertos</a-select-option>
          <a-select-option value="porcentaje_clicks">% Clicks</a-select-option>
          <a-select-option value="porcentaje_conversiones">% Conversiones</a-select-option>
        </a-select>
      </a-col>
      <a-col style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px" v-if="tab_activa == '2'">
        <a-button-group>
          <a-button type="primary" @click="avanzar_mes(true)" >
            <a-icon type="left" /> {{ nombre_mes(anterior_mes(filters.periodo[1])) }}
          </a-button>
          <a-button type="primary" @click="avanzar_mes(false)" >
            {{ nombre_mes(siguiente_mes(filters.periodo[1])) }} <a-icon type="right" />
          </a-button>
        </a-button-group>
      </a-col>

      <!-- contenido tabs -->
      <a-col :span="24">
        <a-tabs v-model="tab_activa" :tabBarStyle="{ display: 'none'}">

          <!-- Listado -->
          <a-tab-pane key="1" tab="">
            <a-row>
              <a-spin :spinning="loadingSearch">
                <itemMessage v-for="message in messages" :key="message.id" :message="message"/>
              </a-spin>
              <a-pagination v-model="paginaActual" :total="parseInt(dashboard.total)" @change="cambiarPagina()" hideOnSinglePage />
              <span v-if="messages.length <= 0" style="margin: 30px 0px; display: block;">No se encontraron resultados para los filtros solicitados.</span>
            </a-row>
          </a-tab-pane>


        </a-tabs>
      </a-col>
    </a-row>
  </div>
</template>

<script>

import moment from 'moment'
import itemMail from '../components/ItemMail.vue'
import detailHover from '../components/DetailHover.vue'
import calendarTag from '../components/CalendarTag.vue'
import utils from '../service/service.js'
import ItemMessage from "@/components/ItemMessage.vue";

moment.locale('ES');

export default {
  name: 'messageList',
  props: ["titulo","valor","hover","filtro_periodo", "filtro_subject", "filtro_order", "filtro_dir", "filtro_to", "filtro_from"],
  components: {
    ItemMessage,
    calendarTag,
    detailHover,

  },
  mixins:[utils],
  data(){ 
    return {
      resumen:{},
      messages : [],
      dashboard : {},
      filters: {
        periodo: [],
        subject: '',
        limit: 3,
        offset: 0,
        from:'',
        to:'',
      },
      orden:{
        asendente: false,
        valor: undefined,
      },
      paginaActual: 1,
      tab_activa: '1',
      loadingSearch: false,
      debounceSearchTimer: null,
    }
  },
  methods: {
    nombre_mes_anio(fecha){
      return moment(fecha, 'DD-MM-YYYY').format('MMMM, YYYY', 'es');
    },
    nombre_mes(fecha){
      return moment(fecha, 'DD-MM-YYYY').format('MMMM', 'es');
    },
    siguiente_mes(fecha){
      var fecha_copia = fecha.clone();
      return fecha_copia.add(1, 'months');
    },
    anterior_mes(fecha){
      var fecha_copia = fecha.clone();
      return fecha_copia.subtract(1, 'months');
    },
    avanzar_mes(atras){
      var $this = this;
      var fecha0_copia = this.filters.periodo[1].clone();
      var fecha1_copia = this.filters.periodo[1].clone();
      if (atras) {
        fecha0_copia.subtract(1, 'months')
        fecha1_copia.subtract(1, 'months');
        this.filters.periodo = [fecha0_copia.startOf('month'), fecha1_copia.endOf("month")];
      }else{
        fecha0_copia.add(1, 'months');
        fecha1_copia.add(1, 'months');
        this.filters.periodo = [fecha0_copia.startOf('month'), fecha1_copia.endOf("month")];
      }
      $this.filters = {...$this.filters, ...{
        periodo : $this.filters.periodo
      }};
      this.filtrar();
    },
    getListData(dia) { //carga mails por dia
      let listData = [...this.messages];
      listData = listData.filter(function(mailing){
       return moment(mailing.fecha_envio, 'YYYY-MM-DD').isSame(dia, 'day');
      });
      return listData;
    },

    cargar_listado(){
      this.filters['limit'] = 10; // en el listado siempre se muestran de a 10
      this.filters['offset'] = 0;
      this.$root.$router.push({
          path: '/messages/',
          query: this.$route.query,
      });
      this.filtrar();
      this.tab_activa = '1'
    },
    promedio(costo, personas){
      if(personas > 0){
        return 'USD '+ (costo / personas).toFixed(2);
      }else
        return '-';
    },
    porcentaje(cantidad, total){ 
      if(total>0){
        cantidad = parseInt(cantidad);
        total = parseInt(total);
        var resultado = ((cantidad / total) * 100).toFixed(2);
        return resultado + '%';
      }else 
        return '-'
    },

    cambiarPagina(){
      var $this = this;
      setTimeout(function(){
        $this.filters['offset'] = ($this.paginaActual * $this.filters['limit']) - $this.filters['limit'];
        $this.filters = {...$this.filters, ...{
          offset : $this.filters.offset

        }};
        
        $this.filtrar();
      }, 100);
    },
    async filtrar (debounce = false) {
      if(this.debounceSearchTimer !== null) {
        clearTimeout(this.debounceSearchTimer);
      }

      this.loadingSearch = true;
      this.debounceSearchTimer = setTimeout(async () => {
        let filtros = {
          periodo: [],
          subject: this.filters.subject,
          limit: this.filters.limit,
          offset: this.filters.offset,
          from: this.filters.from,
          to: this.filters.to,
        };
        if (typeof this.orden.valor != 'undefined') filtros['order'] = this.orden.valor;
        if (this.orden.asendente) filtros['dir'] = 'ASC'; else filtros['dir'] = 'DESC';
        if (this.filters['periodo'].length > 0) filtros['periodo'] = [this.filters['periodo'][0].format('YYYY-MM-DD'), this.filters['periodo'][1].format('YYYY-MM-DD')];


        const {data} = await this.sendRequest({
          method: 'POST',
          url: 'messages/list',
          data: {
            filters: filtros
          },
        })
        this.loadingSearch = false;
        this.messages = data.messages;
        this.dashboard = data.dashboard;

        var query = {};
        if (filtros["periodo"] != "") query['fpe'] = filtros['periodo'];
        if (filtros["subject"] != "") query['ft'] = filtros['subject'];
        if (filtros["from"] != "") query['from'] = filtros['from'];
        if (filtros["to"] != "") query['to'] = filtros['to'];
        if (typeof filtros['order'] != 'undefined') query['order'] = filtros['order'];
        if (typeof filtros['dir'] != 'undefined') query['dir'] = filtros['dir'];
        this.$root.$router.push({
          path: this.$route.params.tab,
          query: query,
        });
      }, debounce ? 800 : 0)
    },

  },
  mounted: function(){
    var $this = this;

    ["filtro_periodo", "filtro_subject", "filtro_order", "filtro_dir", 'filtro_to', 'filtro_from'].forEach(function(filtro){
      if(typeof $this[filtro] != "undefined"){
        if(filtro == "filtro_periodo") $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = [moment($this[filtro][0]), moment($this[filtro][1])];
        else if (filtro == 'filtro_order') $this.orden.valor = $this[filtro];
        else if (filtro == 'filtro_dir' && $this[filtro] == 'ASC') $this.orden.asendente = true; //por defecto queda false
        else {
          var nuevosFiltros=$this[filtro];
          $this.filters[filtro.slice(filtro.indexOf('_') + 1)] = nuevosFiltros;
        }
      }
    });

      $this.cargar_listado();
  },
  watch: {
    tab_activa: function() {
      if (this.tab_activa==1){
        this.filters.periodo=[];
      }
    },
  }  
}
</script>

<style scoped>
  .events {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .events .ant-badge-status {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    text-overflow: ellipsis;
    font-size: 12px;
  }
  .ant-fullcalendar-header{
    display: none;
  }
  .filtros{
    margin: 10px 0px 20px !important;
  }
  .resumen .ant-card{
    border-radius: 5px;
    margin-bottom: 15px;
  }
  .titulo{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
  }
  .tab {
    margin-right: 20px;
    border-bottom: 2px solid;
  }
  .titulo .tabNoSelect{
    font-size: 16px;
    opacity: 0.6;
    border-bottom: none;
    cursor: pointer;
  }
  .titulo .tabNoSelect:hover{
    color: #1890ff;
  }
  .shadow {
    box-shadow: 2px 1px 5px -4px;
  }
  .shadowInputs {
    box-shadow: 1px 1px 5px -5px;
  }
  .calendar{
    background-color: white;
    padding: 10px 10px 10px;
    margin-bottom: 10px;
  }
</style>